"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles console events.
 */
var Console = /*#__PURE__*/function () {
  function Console() {
    _classCallCheck(this, Console);
  }

  _createClass(Console, null, [{
    key: "log",

    /**
     * Logs information.
     *
     * @param {String} message Message to log.
     */
    value: function log(message) {
      //eslint-disable-next-line
      console.log(message);
    }
    /**
     * Logs debug information.
     *
     * @param {String} message Message to log.
     */

  }, {
    key: "debug",
    value: function debug(message) {
      //eslint-disable-next-line
      console.debug(message);
    }
    /**
     * Logs a warning.
     *
     * @param {String} message Message to log.
     */

  }, {
    key: "warn",
    value: function warn(message) {
      //eslint-disable-next-line
      console.warn(message);
    }
    /**
     * Logs an error.
     *
     * @param {String} message Message to log.
     */

  }, {
    key: "error",
    value: function error(message) {
      //eslint-disable-next-line
      console.error(message);
    }
  }]);

  return Console;
}();

exports.default = Console;